<h1 mat-dialog-title>{{ 'companies.detail.privacyDocsCard.dialog.linkTitle' | translate }}</h1>
<mat-dialog-content>
  <div class="row">
    <div class="col-12">
      <mat-form-field class="w-100">
        <mat-label>{{ 'companies.detail.privacyDocsCard.dialog.selectAndCopyLink' | translate }}</mat-label>
        <input matInput [value]="link" readonly (click)="onSelectLink($event)" (focus)="onSelectLink($event)">
      </mat-form-field>
    </div> <!-- /.col-12 -->
  </div> <!-- /.row -->
</mat-dialog-content> <!-- mat-dialog-content -->
<div mat-dialog-actions>
  <div class="row w-100 mt-5">
    <div class="col-12 text-right">
      <a mat-button (click)="onSendLinkByEmail()" mat-raised-button color="accent"
        class="ml-3"><mat-icon fontSet="fal" fontIcon="fa-envelope" class="mr-1"></mat-icon>{{ 'companies.detail.privacyDocsCard.sendByEmail' | translate }}</a>
      <a mat-button (click)="onClose()" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.close' | translate }}</a>
    </div> <!-- /.col -->
  </div> <!-- /.row -->
</div>
